export default "__VITE_ASSET__CxeB8gM2__"